import { Tag } from 'models/install-verification-tags/tag/Tag';
import type { IInstallVerificationTagData, TagType } from 'models/install-verification-tags/types';

export abstract class Communication extends Tag {
  protected lastCheckin: IInstallVerificationTagData['lastCheckin'];

  constructor(tagType: TagType, tagData: IInstallVerificationTagData) {
    super(tagType, tagData);
    this.lastCheckin = tagData.lastCheckin;
  }

  protected isValidLastCheckinData(): boolean {
    if (!this.lastCheckin) {
      return false;
    }

    const parsedDate = new Date(this.lastCheckin);
    if (isNaN(parsedDate.getTime())) {
      return false;
    }

    return true;
  }
}
